export const _notificationsFr = {
    cookiesError: 'Vous devez accepter les cookies pour continuer la navigation sur Alertes Spéciales',
    invalidSession: 'Votre session n\'est plus valide, vous avez été déconnecté.',
    register: 'Connexion',
    logOutSuccess: 'Vous avez été déconnecté avec succès.',
    logOut: 'Déconnexion',
    welcome: 'Bienvenue',
    logInSuccess: 'Connexion réussie',
    signInError1: 'Le nom d\'utilisateur n\'est pas correct.\n5 à 19 caractères\n(a-z, A-Z, 0-9, -)\nExemple: John-Snow01',
    signInError2: 'L\'adresse mail renseignée n\'est pas valide',
    signInError3: `Mot de passe incorrect.
        \n6 à 49 caractères\nDifférent du nom de compte.\nNe doit pas contenir < ou >, sans espace.`,
    signIn: 'Inscription',
    newGameNameInvalid: 'Le nom n\'est pas valide.',
    newGameNameUsed: 'Le nom est déjà utilisé pour une partie.\nVeuillez en choisir un autre.',
    newGame: 'Création d\'une partie',
    newGameCreatedSuccess: 'La partie a été créée avec succès.',
    notAdmin: 'Vous n\'avez pas les droits nécessaires pour gérer cette partie.',
    update: 'La partie a été mise à jour avec succès',
    error: 'Une erreur est survenue. Essayez de nouveau ou contactez le support.',
    deletedGame: 'La partie a été supprimée avec succès.',
    requestJoinGame: 'Votre demande a bien été prise en compte.\nElle doit maintenant être acceptée par les administrateurs de la partie',
    cancelRequestJoinGame: 'Votre demande pour rejoindre la partie a été annulée.',
    refuseNewPlayer: 'La candidature du joueur a été refusée',
    acceptNewPlayer: 'La candidature du joueur a été acceptée',
    copySuccess: 'Copier dans le press-papier avec succès',
    copyError: 'Une erreur s\'est produite, la copie a été annulée',
    newBuilding: 'Le bâtiment a été créé avec succès',
    editedStatus: 'Le statut a été modifié avec succès',
    editedSkill: 'La compétence a été modifiée avec succès',
    editedVehicleModel: 'Le modèle de véhicule a été modifié avec succès',
    editedRank: 'Le grade a été modifié avec succès',
    accessDenied: 'Accès refusé',
    editedBuilding: 'Le bâtiment a été modifié avec succès',
    editedService: 'Le service a été modifié avec succès',
    editedFunction: 'La fonction a été modifiée avec succès',
    addedVehicleToBuilding: 'Le véhicule a été ajouté au bâtiment avec succès',
    editedVehicleInBuilding: 'Le véhicule a été modifié avec succès',
    deletedVehicleInBuilding: 'Le véhicule a été supprimé du bâtiment avec succès',
    planningUpdated: 'La planification a été mise à jour avec succès',
    planningDeleted: 'La planification a été supprimée avec succès',
    editedIncident: 'L\'incident a été modifié avec succès',
    vehicleNotAdded: 'Le véhicule n\'a pas été ajouté à l\'intervention',
};

export const _notificationsEn = {
    cookiesError: 'You must accept cookies to continue browsing on Special Alerts',
    invalidSession: 'Your session is no longer valid, you have been disconnected.',
    register: 'Connection',
    logOutSuccess: 'You have been successfully logged out.',
    logOut: 'Logout',
    welcome: 'Welcome',
    logInSuccess: 'Connection successful',
    signInError1: 'The username is not correct.\n5 to 19 characters\n (a-z, A-Z, 0-9, -)\nExample: John-Snow01',
    signInError2: 'The email address entered is not valid',
    signInError3: 'Incorrect password.\n6 to 49 characters \nDifferent from the account name.\nMust not contain <or>, without spaces.',
    signIn: 'Registration',
    newGameNameInvalid: 'The name is not valid.',
    newGameNameUsed: 'The name is already in use for a game.\nPlease choose a different one.',
    newGame: 'Creating a game',
    newGameCreatedSuccess: 'The game has been created successfully.',
    notAdmin: 'You do not have the necessary rights to manage this game.',
    update: 'The game has been updated successfully',
    error: 'An error has occurred. Try again or contact support.',
    deletedGame: 'The game was successfully deleted.',
    requestJoinGame: 'Your request has been submitted successfully.\It must now be accepted by the game administrators',
    cancelRequestJoinGame: 'Your request to join the game has been cancelled.',
    refuseNewPlayer: 'The player\'s application has been refused',
    acceptNewPlayer: 'The player application has been accepted',
    copySuccess: 'Copy to clipboard successfully',
    copyError: 'An error occurred, the copy was cancelled',
    newBuilding: 'Building successfully created',
    editedStatus: 'The status has been updated successfully',
    editedSkill: 'The skill has been updated successfully',
    editedVehicleModel: 'The vehicle model has been updated successfully',
    editedRank: 'The rank has been updated successfully',
    accessDenied: 'Access denied',
    editedBuilding: 'The building has been updated successfully',
    editedService: 'The service has been updated successfully',
    editedFunction: 'The function has been updated successfully',
    addedVehicleToBuilding: 'The vehicle has been added to the building successfully',
    editedVehicleInBuilding: 'The vehicle has been updated successfully',
    deletedVehicleInBuilding: 'The vehicle has been deleted from the building successfully',
    planningUpdated: 'The planning has been updated successfully',
    planningDeleted: 'The planning has been deleted successfully',
    editedIncident: 'The incident has been updated successfully',
    vehicleNotAdded: 'The vehicle was not added to the intervention',
};

export const _notificationsDe = {
    cookiesError: 'Sie müssen Cookies akzeptieren, um mit dem Surfen auf Spezielle Warnungen fortzufahren',
    invalidSession: 'Ihre Sitzung ist nicht mehr gültig, Sie wurden abgemeldet.',
    register: 'Verbindung',
    logOutSuccess: 'Sie wurden erfolgreich abgemeldet.',
    logOut: 'Ausloggen',
    welcome: 'Herzlich willkommen',
    logInSuccess: 'Erfolgreiche Verbindung',
    signInError1: 'Der Benutzername ist nicht korrekt.\n5 bis 19 Zeichen\n(a-z, A-Z, 0-9, -)\nBeispiel: John-Snow01',
    signInError2: 'Die eingegebene E-Mail-Adresse ist ungültig',
    signInError3: `Falsches Passwort.
        \n6 bis 49 Zeichen\nVerschieden vom Kontonamen.\nDarf keine < oder > enthalten, ohne Leerzeichen.`,
    signIn: 'Registrierung',
    newGameNameInvalid: 'Der Name ist nicht gültig.',
    newGameNameUsed: 'Der Name wird bereits für ein Spiel verwendet.\nBitte wählen Sie einen anderen.',
    newGame: 'Erstellen eines Spiels',
    newGameCreatedSuccess: 'Das Spiel wurde erfolgreich erstellt.',
    notAdmin: 'Sie haben nicht die erforderlichen Rechte, um dieses Spiel zu verwalten.',
    update: 'Das Spiel wurde erfolgreich aktualisiert',
    error: 'Ein Fehler ist aufgetreten. Versuchen Sie es erneut oder wenden Sie sich an den Support.',
    deletedGame: 'Das Spiel wurde erfolgreich gelöscht.',
    requestJoinGame: 'Ihre Anfrage wurde erfolgreich übermittelt.\nSie muss nun von den Spieladministratoren akzeptiert werden',
    cancelRequestJoinGame: 'Ihre Anfrage, dem Spiel beizutreten, wurde abgebrochen.',
    refuseNewPlayer: 'Die Bewerbung des Spielers wurde abgelehnt',
    acceptNewPlayer: 'Die Spielerbewerbung wurde angenommen',
    copySuccess: 'Erfolgreich in die Zwischenablage kopiert',
    copyError: 'Ein Fehler ist aufgetreten, das Kopieren wurde abgebrochen',
    newBuilding: 'Gebäude erfolgreich erstellt',
    editedStatus: 'Der Status wurde erfolgreich aktualisiert',
    editedSkill: 'Die Fähigkeit wurde erfolgreich aktualisiert',
    editedVehicleModel: 'Das Fahrzeugmodell wurde erfolgreich aktualisiert',
    editedRank: 'Der Rang wurde erfolgreich aktualisiert',
    accessDenied: 'Zugriff verweigert',
    editedBuilding: 'Das Gebäude wurde erfolgreich aktualisiert',
    editedService: 'Der Service wurde erfolgreich aktualisiert',
    editedFunction: 'Die Funktion wurde erfolgreich aktualisiert',
    addedVehicleToBuilding: 'Das Fahrzeug wurde erfolgreich zum Gebäude hinzugefügt',
    editedVehicleInBuilding: 'Das Fahrzeug wurde erfolgreich aktualisiert',
    deletedVehicleInBuilding: 'Das Fahrzeug wurde erfolgreich aus dem Gebäude gelöscht',
    planningUpdated: 'Die Planung wurde erfolgreich aktualisiert',
    planningDeleted: 'Die Planung wurde erfolgreich gelöscht',
    editedIncident: 'Der Vorfall wurde erfolgreich aktualisiert',
    vehicleNotAdded: 'Das Fahrzeug wurde nicht zur Intervention hinzugefügt',
};
